import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Card from "../components/card/Card";

export default function Search() {
  const [searchPosts, setSearchPosts] = useState([]);
  let [searchParams] = useSearchParams();

  useEffect(() => {
    const getSearchResults = async () => {
      const searchString = searchParams.get("q").replace(/ /g, "%20");
      const url = `https://www.reddit.com/search/.json?q=${searchString}`;
      const response = await fetch(url);
      const searchResults = await response.json();
      const searchResultsData = [];
      searchResults.data.children.map((item) => searchResultsData.push(item));
      setSearchPosts(searchResultsData);
    };
    getSearchResults();
  }, [searchParams]);

  return (
    <div>
      {searchPosts
        .filter((post) => !post.data.over_18)
        .map((post) => (
          <Card key={post.data.id} post={post} className="card" />
        ))}
    </div>
  );
}
